import { Navigate, Outlet, useLocation } from 'react-router-dom';
const NonToRedirectUrls = ['/', '/corporation-selection', '/dashboard'];

function ProtectedUserRoute() {
    const location = useLocation();
    const isUserLogin = localStorage.getItem('isUserLogin');

    if (!isUserLogin) {
        const redirectTo = location.pathname;
        if (NonToRedirectUrls.includes(redirectTo)) {
            return <Navigate to="login" replace />;
        }
        return <Navigate to={`/login?redirectTo=${encodeURIComponent(redirectTo)}`} replace />;
    }
    return <Outlet />;
}

export default ProtectedUserRoute;
